// extracted by mini-css-extract-plugin
module.exports =  {"root":"a867bdd7c0--root--C3z_i","phone":"a867bdd7c0--phone--PT8d2"};